<template>
  <v-card
    style="margin-top:25px; min-width: 305px;"
  >
    <v-card-text>Request password reset...</v-card-text>
    <v-flex xs12 style="padding:0 10px 0 10px">
      <v-text-field
        label="Username"
        outlined
        v-model="username"
        v-on:keyup.enter="onEnter"
      >
      </v-text-field>
      <div v-if="resetRequested" style="width:100%;color:blue;font-size:smaller;text-align:center;">Please check your e-mail for instructions to reset your password.</div>
    </v-flex>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn :disabled="isResetDisabled || resetRequested" :loading="busy" text @click="reset">REQUEST RESET</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'PasswordResetForm',

  data() {
    return {
      form: {
        username: '',
      },
      isResetDisabled: true,
    };
  },

  computed: {
    username: {
      get() {
        return this.form.username;
      },
      set(value) {
        this.form.username = value;
        this.isResetDisabled = (this.form.username.length === 0);

        this.$emit('usernameChanged', this.form.username);
      },
    },
  },

  methods: {
    onEnter() {
      this.reset();
    },
  },

  props: {
    reset: Function,
    busy: Boolean,
    resetRequested: Boolean,
  },
};
</script>

<style scoped>
/* Sets background hero image */
.heroDash {

  width: 100%;
  height: 100%;
}
#accountIconContainer {
  text-align: center !important;
  background-color: #42A5F5;
}

#accountIcon {
  color: black;
  font-size: 128pt;
}

</style>
